<template>
  <div class="banner-new">
    <div class="main container">
      <div class="banner-title">
        <p class="banner-slogan-one">联结杰出<span>科技领导者</span></p>
        <p>全方位提升自身价值</p>
      </div>
      <h4 class="sub-title">TGO 是汇聚全球科技领导者的高端学习社区。在这里，所有孤军奋战的技术管理者都能找到自己的同侪</h4>
      <div class="type-num">
        <ul>
          <li class="item">
            <span class="item-title">累计学员人数</span>
            <span class="num"><NumGrow :value="2000"></NumGrow>+</span>
          </li>
          <li class="item">
            <span class="item-title">{{isMobile ? '公开学习活动' : '全年公开学习活动'}}</span>
            <span class="num"><NumGrow :value="150"></NumGrow>+</span>
          </li>
          <li class="item">
            <span class="item-title">覆盖技术团队规模</span>
            <span class="num"><NumGrow :value="30"></NumGrow>万+</span>
          </li>
          <li class="item">
            <span class="item-title">{{isMobile ? '分布行业或领域' : '分布行业或领域'}}</span>
            <span class="num"><NumGrow :value="20"></NumGrow>+</span>
          </li>
        </ul>
      </div>
      <div class="join-btn">
        <a href="https://tgo.infoq.cn/join" target="_blank"><Button :use="isMobile ? 'mobile' : 'home'">加入我们，看到自己更多可能</Button></a>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../../base/ego-button-new'
import NumGrow from '../../base/number-grow/number-grow'
export default {
  props: ['isMobile'],
  components: {
    Button,
    NumGrow
  },
  data () {
    return {
      num: 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/bulma/app.sass';

.banner-new {
  display: flex;
  justify-content: center;
  padding-top: 80px;
  color: #fff;
  background: url('https://static001.infoq.cn/resource/image/39/34/3930930be2a35b35d02d95c99fd86a34.png') center center;
  @include mobile {
    padding-top: 48px;
  }
  & .main {
    display: flex;
    flex-direction: column;
    margin-top: 9vw;
    text-align: center;

    & .banner-title {
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      font-size: 45px; font-weight: 600;
      line-height: 1;
      word-spacing: 10px;

      @include mobile {
        display: block;
        font-size: 35px;
        line-height: 50px;
        margin-bottom: 18px;
      }

      & span {
        color: $primary3;
      }

      & .banner-slogan-one {
        margin-right: 14px;

        @include mobile {
          margin-right: 0;
        }
      }
    }

    & .sub-title {
      margin-bottom: 67px;
      font-size: 23px; font-weight: 400;
      line-height: 1;
      color: #d9d9d9;

      @include mobile {
        padding: 0 14px;
        font-size: 14px;
        line-height: 23px;
        text-align: justify;
      }
    }

    & .type-num {
      margin-bottom: 80px;

      @include mobile {
        margin-bottom: 18px;
      }

      & ul {
        display: flex;
        justify-content: space-around;

        @include mobile {
          flex-wrap: wrap;
          padding: 0 24px;
        }

        & li {
          display: flex;
          flex-direction: column;
          position: relative;
          color: #fff;
          font-size: 20px; font-weight: 500;

          &::after {
            content: '';
            position: absolute; right: -55px; top: 10px;
            height: 67px;
            border-right: 1px solid #D7B375;
            opacity: .4;
          }

          &:last-child {

            &::after {
              height: 0;
            }
          }

          @include mobile {
            width: 40%;
            margin-bottom: 30px;
            // justify-content: flex-start;
            text-align: left;
            &::after {
              display: none;
            }
          }

          & span.num {
            display: block;
            margin-top: 15px;
            color: $primary3;
            font-size: 33px; font-weight: 600;
            line-height: 1;
            @include mobile {
              margin-top: 8px;
              font-size: 26px;
            }
          }

          & span.item-title {
            @include mobile {
              font-size: 14px;
            }
          }
        }
      }
    }

    & .join-btn {
      margin: 0 auto 130px;
      width: 350px;

      @include mobile {
        width: 86%;
        margin-bottom: 43px;
      }
    }
  }
}
</style>
